import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './styles.scss';
import { modalViewGA } from '../../../utils/googleAnalytics';

const contextTypes = {
  router: PropTypes.object,
};

class CamInfoComponent extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal(e) {
    e.preventDefault();
    this.props.removeModal();
  }

  componentDidMount() {
    modalViewGA('camGroupInfo');
  }

  generateHtml() {
    return { __html: this.props.item.description };
  }

  render() {
    const { item } = this.props;

    return (
      <div className="modals-popup caminfo-modal u-font-foundation-roman">
        <div className="modal-header d-flex align-items-center">
          <div className="col">{item.title}</div>
          <div className="text-right">
            <a className="closer" href="#" onClick={this.closeModal}></a>
          </div>
        </div>
        <div className="info">
          <div className="" dangerouslySetInnerHTML={this.generateHtml()}/>
        </div>
      </div>
    )
  }

}
const mapStateToProps = (state) => {
  return {};
};
CamInfoComponent.contextTypes = contextTypes;
export default connect(mapStateToProps)(CamInfoComponent);
